import type { PaneItemProps } from '.';
import { ProductBadge } from '@yanolja-rnd/nol-design-system';
import { type FC } from 'react';
import { IcAlarm, IcPlayFill } from '@yanolja-rnd/nol-icons';
import { BaseImage } from '@/app/_components/common/base-image';

export const BadgeArea: FC<PaneItemProps> = ({ type, badgeDesc }) => {
  return (
    <div className="absolute left-8 top-8 z-[1] will-change-[opacity]">
      <div className="flex gap-4">
        {type === 'LIVE' && (
          <ProductBadge type="filled_accent" size="large">
            <span className="relative mr-2 size-14">
              <BaseImage src="https://yaimg.yanolja.com/joy/sunny/static/images/img_live_badge.gif" alt="" />
            </span>
            방송중
          </ProductBadge>
        )}
        {type === 'CATCHUP' && (
          <ProductBadge type="filled_white" size="large">
            다시보기
          </ProductBadge>
        )}
        {type === 'PREVIEW' ? (
          <ProductBadge type="filled_white" size="large">
            <IcAlarm className="size-14" />
            {badgeDesc}
          </ProductBadge>
        ) : (
          <ProductBadge type="filled_blackop" size="large">
            <IcPlayFill className="size-14" />
            {badgeDesc}
          </ProductBadge>
        )}
      </div>
    </div>
  );
};
